import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.css';

// import 'bootstrap/dist/js/bootstrap.js'

Vue.config.productionTip = false

new Vue({

  created(){
      this.$router.push({name: "devmode"})
  },

  router,
  store,
  render: h => h(App)
}).$mount('#app')
